/*------------------------------------------------------------------
Fold shapes animation
------------------------------------------------------------------*/

import $ from 'jquery';
import TweenLite from 'gsap';

function tweenProperty(target) {
    TweenLite.to(target, random(.5, 1.5), {
        x: random(7, 15),
        y: random(7, 15),
        rotation: random(-5, 5),
        onComplete: tweenProperty,
        onCompleteParams: [target]
    });
}

function random(min, max) {
    return min + Math.random() * (max - min);
}

$('.movement__item svg').each(function () {
    if (window.outerWidth > 768) tweenProperty($(this)[0]);
});

